/**
 * How long ago, in words.
 *
 * Exists because a monitor's most important field is the *age* of its reading, and an ISO timestamp
 * does not communicate age — a person has to subtract it from the current time in their head, which
 * they will not do, which is how a four-hour-old check gets read as current.
 */
export function relativeTime(iso: string): string {
  const seconds = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));

  if (seconds < 60) {
    return 'just now';
  }

  if (seconds < 3600) {
    const minutes = Math.round(seconds / 60);

    return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  }

  if (seconds < 86400) {
    const hours = Math.round(seconds / 3600);

    return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  }

  const days = Math.round(seconds / 86400);

  return `${days} day${days === 1 ? '' : 's'} ago`;
}

/** A duration in seconds, for an outage that has ended. */
export function humanDuration(seconds: number | null): string {
  if (seconds === null) {
    return 'ongoing';
  }

  if (seconds < 60) {
    return `${seconds}s`;
  }

  if (seconds < 3600) {
    return `${Math.round(seconds / 60)}m`;
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.round((seconds % 3600) / 60);

  return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
}
